var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{attrs:{"id":"loading-dash"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-white text-uppercase h1"},[_c('b',[_vm._v("Aguarde..")])])
}]

export { render, staticRenderFns }